import { render, staticRenderFns } from "./OtherApplySignApprove.vue?vue&type=template&id=2e284dd7&scoped=true"
import script from "./OtherApplySignApprove.vue?vue&type=script&lang=js"
export * from "./OtherApplySignApprove.vue?vue&type=script&lang=js"
import style0 from "./OtherApplySignApprove.vue?vue&type=style&index=0&id=2e284dd7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e284dd7",
  null
  
)

export default component.exports